export const projects = [
  {
    title: "Tassel - Micro-Volunteering App for UCSC Graduates",
    subtitle: "React, Material UI, Node, PostgreSQL, AWS Amplify",
    description:
      "Building a scalable, responsive micro-volunteering platform that will enable UCSC students, staff, faculty, and Alumni to post and share events with a 5-person team following Scrum/Agile software development practices",
    image: "./tassel.gif",
    link: "https://github.com/mikeriepe/tassel-ucsc",
  },
  {
    title: "BAM! File Transfer App",
    subtitle: "React, Node, Express, MongoDB, WebTorrent API",
    description:
      "Designed and developed a cross-compatible web application that lets users transfer files by bumping their phones at each other utilizing WebTorrent API with a 5-person Scrum team",
    image: "./bam.gif",
    link: "https://github.com/BAM-File-Transfer/BAM",
  },
  {
    title: "Fusion Tech, Coin-Based Portable Mobile Device Charger",
    subtitle: "C++, Arduino, Circuit Design, Product Design, Marketing",
    description:
      "I and my partner designed, developed, and manufactured a portable mobile device charger that's triggered by coins to be used in service industry businesses. We built a fully working prototype; however, we couldn't go into mass production of the product because of the raising material costs and reduced demand in the service industry due to the pandemic. It was a very fun project where I learned a lot about circuit design, finite state machine, product design, marketing, manufacturability of a product etc.",
    image: "./fusiontech.gif",
  },
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  "JavaScript",
  "Python",
  "C++",
  "React",
  "Node",
  "Material UI",
  "PostgreSQL",
  "AWS Amplify",
  "Scrum/Agile",
  "REST",
  "HTML",
  "CSS"
];



// WEBPACK FOOTER //
// ./src/data.js